module.exports = __webpack_public_path__ + "static/media/A2i.25898c37.png";